import { ExportToCsv } from 'export-to-csv';
import { renderToString } from 'react-dom/server';

function getValueByKey(obj, key, value = []) {
  if (!obj || typeof obj !== 'object') {
    return null;
  }
  if (Object.prototype.hasOwnProperty.call(obj, key)) {
    value.push(obj[key]);
  } else {
    Object.values(obj).forEach((_value) => {
      getValueByKey(_value, key, value);
    });
  }
  return value[0];
}

function dataForExport(dataSource, columns) {
  if (dataSource.length === 0) {
    const exportRow = {};
    columns.forEach((column) => {
      const propName = column.exportTitle || column.dataIndex || column.key;
      const title = propName.replace(/\r?\n|\r/g, '');
      if (title) {
        exportRow[title] = '';
      }
    });
    return [exportRow];
  }

  return (
    dataSource
      // Uncomment this for enable exporting with antd table internal filtering and sorting.
      // TODO: Use onChange even in antd table to track the filtering and sorting events.
      //
      // .filter((data) => {
      //   return columns.every((column) => {
      //     const { filteredValue, onFilter } = column;
      //     return !(
      //       onFilter &&
      //       filteredValue &&
      //       filteredValue.length > 0 &&
      //       filteredValue.filter((value) => onFilter(value, data)).length === 0
      //     );
      //   });
      // })
      // .sort((a, b) => {
      //   const sort = (column) => {
      //     const { sorter, sortOrder } = column;
      //     if (
      //       sorter &&
      //       sorter instanceof Function &&
      //       !(typeof sortOrder === 'boolean')
      //     ) {
      //       return sorter(a, b, sortOrder);
      //     }
      //     return 0;
      //   };
      //   const sortBy =
      //     columns.find((column) => !!column.sortOrder) ||
      //     columns.find((column) => !!column.defaultSortOrder);
      //   return sortBy ? sort(sortBy) : 0;
      // })
      //
      .map((row, idx) => {
        const exportRow = {};
        columns.forEach((column) => {
          if (column.children) {
            column.children.forEach((child) => {
              const propName =
                child.exportTitle || child.dataIndex || child.key;
              const title = propName.replace(/\r?\n|\r/g, '');
              if (title) {
                if (child.exportData) {
                  exportRow[title] = child.exportData(row);
                } else {
                  const rawData = getValueByKey(row, child.key);
                  if (child.render && rawData === undefined) {
                    try {
                      exportRow[title] = renderToString(
                        child.render(rawData, row, idx)
                      )?.replace(/(<([^>]+)>)/g, '');
                    } catch (e) {
                      exportRow[title] = '';
                    }
                  } else {
                    exportRow[title] = rawData;
                  }
                }
              }
            });
          } else {
            const propName =
              column.exportTitle || column.dataIndex || column.key;
            const title = propName.replace(/\r?\n|\r/g, '');
            if (title) {
              if (column.exportData) {
                exportRow[title] = column.exportData(row);
              } else {
                const rawData = row[propName];
                if (column.render) {
                  try {
                    exportRow[title] = renderToString(
                      column.render(rawData, row, idx)
                    )?.replace(/(<([^>]+)>)/g, '');
                  } catch (e) {
                    exportRow[title] = '';
                  }
                } else {
                  exportRow[title] = rawData;
                }
              }
            }
          }
        });
        return exportRow;
      })
  );
}

function onAntdTableExport(_entityList, columns) {
  return () => {
    const csvExporter = new ExportToCsv({
      filename: `velaris_export_${new Date().getTime()}`,
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });
    csvExporter.generateCsv(dataForExport(_entityList, columns));
  };
}

export default onAntdTableExport;
